export function downloadIterable(
  lines: Iterable<string>,
  filename: string,
  // useAnchorDownload: boolean = true,
) {
  // NOTE DHL doesnt have filepicker Im afraid this isnt supported anymore anyway (note the as any in `downloadViaFileSystemApi`)
  // const supportsFileSystemAccess =
  //     window.isSecureContext &&
  //     'showSaveFilePicker' in window &&
  //     (() => {
  //         try {
  //             return window.self === window.top;
  //         } catch {
  //             return false; // Cross-origin ⇒ window.top throws
  //         }
  //     })();

  // const method = useAnchorDownload || !supportsFileSystemAccess ? 'anchor' : 'fs-api';
  // if (method === 'anchor') downloadViaFileSystemApi(lines, filename);

  downloadViaAnchor(lines, filename);
}

function downloadViaAnchor(lines: Iterable<string>, fileName: string): void {
  const blob = new Blob(Array.from(lines), { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

async function _downloadViaFileSystemApi(
  lines: Iterable<string>,
  fileName: string | undefined,
): Promise<void> {
  const fileHandle = await (window as any).showSaveFilePicker({
    suggestedName: fileName,
  });
  const writer = (await fileHandle.createWritable()).getWriter();

  for (const line of lines) {
    await writer.ready;
    await writer.write(line);
  }

  await writer.close();
}
